import WhitepapersHub from "./whitepapers/WhitepapersHub";

export { Page }

function Page() {
  return <WhitepapersHub />;
}
